<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.name" placeholder="请输入姓名" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.phone" placeholder="请输入手机号码" class="filter-item" style="width: 250px;" clearable />

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payMoney || 0 }}</div>
            <div class="subtitle">充值总金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payCount || 0 }}</div>
            <div class="subtitle">充值总次数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="支付用户" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.user.avatar" class="user-avatar">
            <span>{{ scope.row.user.name }}</span>
            <span>{{ scope.row.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="支付金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>

      <el-table-column label="支付时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_time }}
        </template>
      </el-table-column>

      <el-table-column label="赠送优惠券额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.coupon_limit }}
        </template>
      </el-table-column>

      <el-table-column label="剩余优惠券额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.remaining_coupon_limit }}
        </template>
      </el-table-column>

      <el-table-column label="赠送余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance_limit }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  var moment = require("moment");

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          name: "",
          phone: "",
          start_date: "",
          end_date: "",
        },
        dateArr: null,
        payMoney: null,
        payCount: null,
      };
    },
    created() {
      this.listQuery.start_date = moment().format("YYYY-MM-DD");
      this.listQuery.end_date = moment().format("YYYY-MM-DD");
      this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
      this.getList();
    },
    computed: {
      ...mapGetters(["schools", "school_id", "user"])
    },
    watch: {
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      }
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/rechargeOrder/list",
          method: "get",
          params: this.listQuery,
          timeout: 6000000,
        }).then((response) => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.payMoney = response.data.payMoney;
          this.payCount = response.data.payCount;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
    },
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
